import { Component, EventEmitter, HostBinding, Input, Output, OnInit, ViewChild, ElementRef, NgModule, OnDestroy, signal } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PopupData, PopupDataCustomEvent } from '../../interfaces/popup-data'
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from "@angular/material/button";
import { lastValueFrom, skip, Subscription, take } from 'rxjs';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { ElevationService } from '@tt-lib/services/elevation.service';
import { MapService } from '@tt-lib/services/map.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { PopupService } from '@tt-lib/services/popup.service';
import { MarkerService } from '@tt-lib/services/marker.service';


@Component({
  templateUrl: './popup.component.html',
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    MatButtonModule
  ],
  styleUrls: ['./popup.component.scss'],
  selector: 'tt-popup',
  animations: [
    trigger('state', [
      state('opened', style({
        transform: 'translateY(0%)'
        //transform: 'scale(1.0)'
      })),
      state('closed', style({
        transform: 'translateY(-20%)', //😁
        //transform: 'scale(0.8)',
        opacity: 0.0
      })),
      transition('opened => closed',
        //animate('100ms ease-in')
        animate('0.1s cubic-bezier(0.0, 0.0, 0.2, 1)')),
      transition('closed => opened',
        //animate('100ms ease-in')
        animate('0.1s cubic-bezier(0.0, 0.0, 0.2, 1)')),
    ])
  ],
  standalone: true
})

export class PopupComponent implements OnDestroy {
  @NgModule({
    declarations: [],
    imports: [
      // CommonModule,
      // MatTooltipModule
      // ,
      TranslateModule
    ],
    exports: []
  })

  // @HostBinding('@state') state: 'opened' | 'closed' = 'closed';
  @HostBinding('@state') _state: 'closed' | 'opened';

  coordinates: number[];

  //zoomextent has priority over zoomlevel
  zoomlevel: number;
  zoomextent: number[];
  zoomToFeatureLink: boolean;

  emitCustomEvent: PopupDataCustomEvent;
  bigTitle: string;
  title: string;
  className: string;

  /**
  * content with object value should only be used when the popup template has a specific swith case for this type 
  */
  content: string | { [key: string]: any };

  showFeatureElevation: boolean;
  readonly featureElevation = signal('');

  @Input()
  get type() {
    return this._type;
  }
  set type(type: string) {
    this._type = type;
  }
  private _type;

  @Input()
  get popupData() {
    return this._popupData;
  }
  set popupData(popupData: PopupData) {
    this.type = popupData.type;
    this.title = popupData.title;
    this.bigTitle = popupData.bigTitle;
    this.content = popupData.content;
    this.zoomToFeatureLink = popupData.zoomToFeatureLink
    this.coordinates = popupData.coordinates;
    this.zoomlevel = popupData.zoomlevel;
    this.zoomextent = popupData.zoomextent;
    this.type = popupData.type;
    this.emitCustomEvent = popupData.customEvent;
    this.className = popupData.className;
    this.showFeatureElevation = popupData.showFeatureElevation;
    //  this.state = 'opened';

    if (this.showFeatureElevation) {
      this.setFeatureElevation();
    }
  }
  private _popupData;

  @Input()
  get state() {
    return this._state;
  }
  set state(type) {
    this._state = type;
  }
  //private _state;

  @Output() popupCloseEvent: EventEmitter<any> = new EventEmitter();
  @Output() zoomToFeatureEvent: EventEmitter<any> = new EventEmitter();
  @Output() emitEvent: EventEmitter<any> = new EventEmitter();

  private subscriptions: Subscription;

  constructor(
    private mapService: MapService,
    private popupService: PopupService,
    private markerService: MarkerService,
    private toggleEventService: ToggleEventService,
    private backEventService: BackEventService,
    private elevationService: ElevationService
  ) {

    this.subscriptions = new Subscription();
    this.subscriptions.add(this.toggleEventService.emitter$.subscribe(
      (toggleEvent: ToggleEventType) => {
        if (toggleEvent.forwardedFor === 'popup' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
          this.popupCloseEvent.emit();
        }
      })
    );
    this.subscriptions.add(
      toObservable(this.mapService.contextMenuPausedRef).pipe(skip(1)).subscribe(value => {
        //we could hide only the contextmenu, but it's better to close any popup and marker
        //especially when trace editing starts, it's difficult to close the popup manually without drawing actions
        if (value.paused /*&& this.type === 'ContextMenuPopup'*/) {
          //this.popupService.hideInCaseOfType('ContextMenuPopup');
          this.popupService.hide();
          this.markerService.clearAll()
        }
      })
    );

    this.backEventService.registerOpenedWindow({ windowName: 'popup', isAutoCloseableWindow: false });
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async setFeatureElevation() {
    this.featureElevation.set('');
    let elevationForTemplate: string = null;
    try {
      const responseData = await lastValueFrom(this.elevationService.getElevationForSingleCoordinate(this.coordinates).pipe(take(1)), { defaultValue: [] });
      let elevation = Array.isArray(responseData) && responseData.length > 0 && typeof responseData[0] === 'object' && typeof responseData[0].z === 'number' ? responseData[0].z : -1;
      elevationForTemplate = elevation > -1 ? (Math.round((elevation + Number.EPSILON) * 100) / 100).toFixed(2).replace(/(0)+$/, '').replace(/\.$/, '') : '';
    } catch (error) {
      console.error('error while getting elevation for coordinate', error);
    }
    if (elevationForTemplate) {
      this.featureElevation.set(elevationForTemplate);
    }
  }
}
